/**
* MPF CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the MPF CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'mpf-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.mpf-cta' ).each( function( key, component ) {
        const leftSplide = new Splide( $( component ).find( '.splide--mpf-cta--left' )[0], {
          direction: 'ttb',
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '20px',
          height: window.innerWidth < 1024 ? '264px' : $( '.mpf-cta__content' ).height(),
          autoWidth: true,
          autoHeight: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          autoScroll: {
            speed: 0.5,
          },
        } );

        const rightSplide = new Splide( $( component ).find( '.splide--mpf-cta--right' )[0], {
          direction: 'ttb',
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '20px',
          height: window.innerWidth < 1024 ? '264px' : $( '.mpf-cta__content' ).height(),
          autoHeight: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          autoScroll: {
            speed: -0.5,
          },
        } );

        leftSplide.mount( {AutoScroll} );
        rightSplide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'mpf-cta', COMPONENT );
} )( app );
